import actions from '@/core/store/ata/documentos-ata/anexos/actions'
export default {
	actions,
}
